import React from 'react';
import { images } from 'assets/images/import-images';

const PreLoader: React.FC = () => {
  return (
    <div id="LoaderAnimation">
      <img className="loadingVoala" src={images.voalaLoading} alt="carregando" />
    </div>
  );
};

export default React.memo(PreLoader);
